<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <input
        id="form-field-{{ formField.id }}"
        type="text"
        class="form-control"
        pattern="^[0-9]\d{10}$"
        minlength="11"
        maxlength="11"
        inputmode="numeric"
        appFocus
        [appAutoFocus]="formField.isNeedToFocus"
        [attr.name]="formField.name || formField.id"
        [name]="formField.name || formField.id"
        [placeholder]="formField.placeholder"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (drop)="onDrop($event)"
        [ngClass]="{ 'ng-invalid': formService.isSubmitted && field.errors }"
        [required]="formField.isRequired"
        [(ngModel)]="formField.value"
        #field="ngModel"
        appAccountNumberValidator />
    @if (formService.isSubmitted && formField.isRequired && !formField.value) {
        <div class="text-danger">{{ 'Please fill this field' | translate }}</div>
    }

    @if (formService.isSubmitted && field.value && field.errors?.validateAccount?.invalid) {
        <div class="text-danger">{{ 'Invalid account number' | translate }}</div>
    }
    @if (formService.isSubmitted && field.value && field.errors?.minlength) {
        <div class="text-danger">{{ 'Must be an 11-digit number (ex. 11112233333)' | translate }}</div>
    }
</div>
